export const CustomPopoverCss = {
  mainTextFieldSx: {
    '& .MuiOutlinedInput-root': {
      height: '40px', // Reduced height to 40px
      paddingTop: '0',
      paddingBottom: '0px',
      display: 'flex',
      alignItems: 'center'
    },
    '& .MuiInputLabel-root': {
      marginTop: '-6px',
      color: 'var(--color-text-purple)'
    },
    '& .MuiInputLabel-shrink': {
      marginTop: '0px',
      color: 'var(--color-text-purple)'
    },
    '& .MuiInputBase-input': {
      color: 'var(--color-primary)',
      fontFamily: 'Inter',
      fontSize: 'var(--font-size-14)',
      fontWeight: 500,
      lineHeight: 'var(--line-height-20)',
      textAlign: 'left'
    }
  },
  mainTextFieldInputProp: {
    padding: '0px',
    paddingRight: '15px',
    gap: '0px',
    borderRadius: '4px',
    opacity: '0px',
    maxWidth: '11rem',
    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none' // Removes the default border
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent' // Removes the hover effect by setting border color
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent' // Ensures the border color remains transparent on focus
      }
    }
  },
  subInputField: {
    '& .MuiOutlinedInput-root': {
      height: '20px', // Reduced height to 40px
      paddingTop: '0',
      paddingBottom: '0px',
      display: 'flex',
      alignItems: 'center'
    },
    '& .MuiInputLabel-root': {
      marginTop: '-6px',
      color: 'var(--color-text-purple)'
    },
    '& .MuiInputLabel-shrink': {
      marginTop: '0px',
      color: 'var(--color-text-purple)'
    },
    '& .MuiInputBase-input': {
      color: 'var(--color-primary)',
      fontFamily: 'Inter',
      fontSize: 'var(--font-size-14)',
      fontWeight: 500,
      lineHeight: 'var(--line-height-20)',
      textAlign: 'left'
    }
  },
  option: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-near-black)'
  },
  colorBox: {
    width: 16,
    height: 10,
    borderRadius: '50%',
    marginRight: 1
  },
  endAdornmentBox: {
    display: 'flex',
    alignItems: 'center'
  },
  filterCountBox: {
    height: '20px',
    width: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: 'var(--color-primary)'
  },
  filterCountText: {
    color: 'white',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  },
  divider: {
    height: '38px',
    m: 0.5,
    borderColor: 'var(--color-purple-deep-alt)'
  },
  clearIcon: {
    height: '20px',
    width: '20px',
    cursor: 'pointer',
    color: 'var(--color-primary)'
  },
  moreFilterMainTextFieldBox: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '15px',
    gap: '30px'
  },
  keywordGoldenRatioMainBox: {
    maxWidth: '15rem'
  },
  keywordGoldenRatioText: {
    mb: 1,
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  keywordGoldenRatioTextFieldBox: {
    display: 'flex',
    gap: '8px'
  },
  keywordGoldenRatioTextFieldInputProps: {
    padding: '0px',
    gap: '0px',
    borderRadius: '4px',
    opacity: '0px'
  },
  moreFilterBtnBox: {
    display: 'flex',
    padding: '15px',
    gap: '5px',
    maxWidth: '19rem',
    marginLeft: 'auto'
  },
  btnFullWidth: {
    width: '100%'
  },
  list: {
    maxWidth: 250,
    minWidth: '15rem'
  },
  showColorBox: {
    display: 'flex',
    alignItems: 'center'
  },
  colorOption: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    marginRight: 1
  },
  listItemShowFields: {
    display: 'flex',
    gap: '5px'
  },
  applyBtn: {
    width: '100%',
    height: 'fit-content',
    padding: '6px, 16px, 6px, 16px ',
    paddingTop: '6px',
    paddingBottom: '6px',
    gap: '8px',
    borderRadius: '6px',
    opacity: '0px'
  },
  input: {
    '& input': {
      fontFamily: 'Inter',
      fontSize: 'var(--font-size-14)',
      fontWeight: 400,
      lineHeight: 'var(--line-height-20)',
      textAlign: 'left',
      color: 'var(--color-text-dark)'
    }
  },
  customRange: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    ml: 2,
    mt: 1,
    color: 'var(--color-text-purple)'
  },
  dividerHorizontal: {
    color: 'var(--color-text-dark)',
    mt: 1
  },
  alert: {
    padding: '10px'
  },
  keywordResearchKdSubOptions: {
    fontFamily: 'Inter',
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: 'var(--line-height-14)',
    textAlign: 'left',
    color: 'var(--color-text-purple)'
  },
  intentInputSx: {
    padding: '4px',
    borderRadius: '4px',
    fontSize: 'var(--font-size-14)',
    fontWeight: 'bold',
    paddingTop: '0px',
    paddingBottom: '0px'
  },
  arrowIconSx: {
    color: 'var(--color-primary)'
  }
};
